import React from 'react';

const ServiceSection = () => {
    return (
        <div>
            <div className="hero bg-amber-100  my-20">
  <div className="hero-content justify-around flex-col lg:flex-row-reverse">
    
   
    <img  src="https://i.ibb.co/nCnPFFg/gantas-vaiciulenas-2-WYVss-Vd-YPQ-unsplash.jpg" alt="" className="w-2/6 rounded-lg shadow-2xl" />
 
    <div className='w-2/5'>
    <p className='text-[#318DB9]'>THE BEST TRAVEL AGENCY</p>
    <p className='text-5xl font-bold text-[#0F2454]'>DISCOVER THE <span className='text-[#2095AE]'>WORLD</span>  WITH OUR GUIDE</p>
      
      <p className="py-6">TravelZone is a travel AGENCY founded in 2002 that is ranked among the top 50 tour companies in the world. The firm has established its APAC headquarters in Singapore and is quickly growing its worldwide staff of expert meeting planners. As a result, Hotel Planner provides over 100,000 worldwide hotel partners with pricing ranging from affordable to luxury, providing you with more options than ever before.</p>
      
    </div>
  </div>
</div>
<div className="hero bg-amber-100  my-28">
  <div className="hero-content justify-around flex-col lg:flex-row">
    
  <div className='w-1/2 relative'>
    <img src="https://i.ibb.co/QXzBTdx/artem-zhukov-F7xo7-J1wu08-unsplash.jpg" alt='' className="w-4/5 h-full rounded-lg shadow-2xl" />
    <img src="https://i.ibb.co/0s724QX/daniel-j-schwarz-ni0-FHXDMTVI-unsplash.jpg" alt='' className="w-4/6 absolute border-8 right-5 top-64 rounded-lg shadow-2xl" />
    </div>
    <div className='w-2/5'>
    <p className='text-[#318DB9]'>MOST POPULAR</p>
    <p className='text-5xl font-bold text-[#0F2454]'>TRAVEL COUNTRIES</p>
      
      <p className="py-6">We provide you with interesting and exciting tours to different parts of the world. Whenever you are planning for a trip on your vacation, you want it to be the best vacation of your life. We are here to listen to your needs and arrange all the bookings regarding hotels, flights, etc. on time. Our services include domestic and international trips with all the possible ways to make each day precious.</p>
      
    </div>
  </div>
</div>


        </div>
    );
};

export default ServiceSection;